module.exports = __webpack_public_path__ + "img/erp.ee2a98d1.svg";